export default {
  addrOne: "إمبراطورية سينيماس ، جيزان",
  welcome: "امباير سينما",
  EmpireCinemas: "امباير سينما",
  LocationName: "اسم الموقع",
  Gizan: "جازان",
  Jizan: "جازان",
  Jazan: "جازان",
  EmpireCinemasGizan: "امباير سينما- جازان",
  JizanAlRashidMall: "سوق الراشد- جيزان",
  JazanAlRashidMall: "سوق الراشد- جيزان",
  GizanAlRashidMall: "سوق الراشد- جيزان",
  WelcomeToEmpireCinemas: "مرحبا بكم في امباير سينما!",
  PleaseSelectYourPrefferedLanguage: "رجاء قم باختيار لغتك المفضلة ",
  Arabic: "العربیة",
  PickUpYourTicket: "استلم تذكرتك",
  BookYourShow: "احجز عرضك",
  LetsGetYouYourTickets: "لنذهب لاستلام تذاكرك!",
  PleaseEnterYourBookingId: "رجاءً أدخل رقم الحجز",
  Proceed: "استمرار",
  ReleaseDate: "يوم الاصدار",
  Back: "الرجوع",
  SelectMovie: "الفيلم المختار",
  Exit: "مخرج",
  SelectShowTimes: "اختيار أوقات العرض",
  Synopsis: "الملخص",
  Actors: "الممثلين",
  DirectedBy: "الاخراج",
  FORMAT: "",
  PICKADATE: "اختر التاريخ ",
  CHOOSEYOURSHOWTIME: "اختر وقت العرض",
  Next: "التالي",
  SelectSeat: "اختر المقعد",
  FoodAndDrinks: "الأغذية والمشروبات",
  Scan_And_Pay: "امسح الباركود وسدد عن طريق الجوال",
  YourSelection: "اختيارك",
  Available: "متوفر",
  Unavailable: "غير متوفر",
  HouseSeat: "مقعد البيت",
  PleasePickASeatCategory: "یرجى اختیار نوع المقعد",
  SelectYourSeat: "اختر المقعد!",
  GrabABite: "خذ لك لقمة!",
  SomethingToSnackOn: "وجبة خفيفة؟",
  ConfirmOrder: "تأكيد الطلب",
  SkipToSummary: "تجاوز للملخص",
  AlmostDoneSignInToConfirmYourBooking:
    "على وشك الانتهاء - تسجيل الدخول لتأكيد الحجز",
  YourEmail: "بريد إلكتروني",
  YourContactNo: "رقم التواصل ",
  Confirmation: "التأكيد",
  SubTotal: "المجموع",
  Tickets: "التذاكر",
  Checkout: "صفحة الدفع",
  PrintTickets: "طباعة التذكرة",
  Cinema: "سينما",
  Screen: "الشاشة",
  Time: "الوقت",
  Seats: "المقاعد",
  ChangeLanguage: "تغییر اللغة",
  firstRow: "الصف الأول",
  bachelor: "أعزب",
  family: "عائلي",
  ReceiptNo: "رقم الإيصال:",
  PickupCode: "التقاط الرمز",
  Home: "الصفحة الرئيسية",
  January: "ینایر",
  February: "فبرایر",
  March: "مارس",
  April: "أبریل",
  May: "مایو",
  June: "یونیو",
  July: "یولیو",
  August: "أغسطس",
  September: "سبتمبر",
  October: "أكتوبر",
  November: "نوفمبر",
  December: "دیسمبر",
  Sunday: "الأحد",
  Monday: "الاثنین",
  Tuesday: "الثلاثاء",
  Wednesday: "الاربعاء",
  Thursday: "الخمیس",
  Friday: "الجمعة",
  Saturday: "السبت",
  Today: "الیو",
  Tomorrow: "غدا",
  AM: "صباحا",
  PM: "مساء",
  Normal: "عادي",
  English: "الإنجلیزیة",
  Items: "العناصر",
  TillYourBookingExpires: "حتى تنتهي صلاحية الحجز الخاص بك",
  CLOSE: "اغلق",
  ThePhoneNumberFieldIsRequired: "مطلوب حقل رقم الهاتف",
  TheUsernameFeildIsRequired: "مطلوب حقل اسم المستخدم",
  ThePasswordFeildIsRequired: "مطلوب حقل كلمة المرور",
  ForgotPassword: "هل نسيت كلمة المرور",
  BookingFee: "رسوم الحجز",
  IncludesAllTaxesAndFees: "يشمل جميع الضرائب والرسوم",
  IAgree: "أنا موافق",
  Cancel: "إلغاء",
  RulesOfEntry: "قواعد الدخول",
  SessionExp: "انتهت الجلسة",
  PleaseWait: "انتظر من فضلك...",
  OR: " و ",
  AreUSure: "هل أنت متأكد أنك تريد إلغاء الحجز؟",
  Yes: "نعم",
  No: "لا",
  minutes: "دقائق",
  PLEASESELECTYOUR: "يرجى اختيار الخاص بك",
  PREFFEREDLANGUAGE: "اللغة المفضلة",
  BookingID: "رقم معرف الحجز",
};



// WEBPACK FOOTER //
// ./src/helper/ln/ar.js